




























import { Component, Prop, Watch } from "vue-property-decorator";
import Vue from "vue";
import BaseModel from "@/models/base/BaseModel.model";
import HttpClient from "@/core/HttpResources/BaseHttpClient";
import ApiQueryOption from "@/models/base/ApiQueryOption.model";
import { Utils } from "@/core/Utils";
import BaseRepository from "@/core/HttpResources/BaseRepository";
import Beneficiario from "../../models/beneficiario/beneficiario.model";
import BaseHttpClient from "@/core/HttpResources/BaseHttpClient";

@Component({})
export default class BeneficiarioBuscador extends Vue {
  @Prop() public controller!: string;
  @Prop() public placeholder!: string;
  @Prop() public size!: string;
  @Prop() public customClasses!: string;
  @Prop() public whereParams!: string;
  @Prop() public include!: string;
  @Prop() public value!: number | string | null;

  loading = false;
  term = String();
  repository = new BaseRepository<Beneficiario>(this.controller || "beneficiario");
  client = new BaseHttpClient("beneficiario");

  get clases() {
    let r = this.customClasses || String();
    if (this.size) 
      r += this.size;
    return r;

  }
  get isCedula() {
    return Utils.isCedula(this.term);
  }
  get _placeholder() {
    return this.placeholder || "Buscar...";
  }

  get query() {
    let ced = this.term.replace(/-/g, "");
    let where = String();
    if (this.whereParams) {
      where = this.whereParams;
      where += `&persona.cedula="${ced}"`;
    } else where = `persona.cedula="${ced}"`;
    return where;
  }
  get includes() {
    let include = "Persona";
    if (this.include) include += this.include;

    return include;
  }
  async getDataAsync(value: string) {
    if (!value) return;
    try {
      this.loading = true;
     // this.client.getAsync<any>("GetProfile",{cedula:this.term.replace(/-/g, "")});
      let result = await this.repository.one(this.query, this.includes);
      this.onSelect(result);
    } catch (e) {
      this.$buefy.toast.open({
        message: "No se pudo completar la busqueda del beneficiario.",
        type: "is-danger"
      });
    } finally {
      this.loading = false;
    }
  }

  onSelect(value: Beneficiario) {
    this.$emit("select", value);
    this.$emit("input", value ? value.id : undefined);
  }

//   @Watch("value")
//   onValue(value: any) {
//     if (!value) {
//       this.onSelect(value);
//       return;
//     }

//     if (isNaN(value)) {
//       this.onSelect(value);
//       return;
//     }
//     if (Utils.isCedula(value)) this.getDataAsync(value);
//   }
}
